module.exports = __webpack_public_path__ + "static/2-509f2876e077a3fc25a0bf996cd44ec3.svg";